var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Input } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var AddVariantNoteModal = /** @class */ (function (_super) {
    __extends(AddVariantNoteModal, _super);
    function AddVariantNoteModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onNoteChange = function (event, data) {
            var str = data.value;
            _this.setState({ note: str });
        };
        _this.submit = function () {
            _this.props.postRequest("/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) + "/probe-set-families/id/" + encodeURIComponent(_this.props.psfId.toString()) + "/variants/id/" + encodeURIComponent(_this.props.variantId.toString()) + "/notes", {
                note: _this.state.note,
            });
        };
        _this.state = {
            note: ''
        };
        return _this;
    }
    AddVariantNoteModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errorPath: '/note', errors: this.props.state.errors, required: true, labelContent: 'Note' },
                React.createElement(Input, { onChange: this.onNoteChange, placeholder: 'This is the best catalog entry', value: this.state.note }),
                React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', label: 'Add note', labelPosition: 'left', onClick: this.submit, positive: true })));
    };
    return AddVariantNoteModal;
}(React.PureComponent));
export default AddVariantNoteModal;
//# sourceMappingURL=AddVariantNoteModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddVariantNoteModal.js
// module id = 1319
// module chunks = 0